export enum ApprovalsReviewKind {
  APPROVE = 'approve',
  DECLINE = 'decline',
  COMMENT = 'comment',
  DEFAULT = '',
}

export enum ApprovalsReviewStatus {
  APPROVED = 'approved',
  PENDING = 'pending',
  DECLINED = 'declined',
  COMMENTED = 'commented',
  DEFAULT = 'notified',
}

export enum ApprovalWorkflowExecutionStatus {
  COMPLETED = 'completed',
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  FAILED = 'failed',
}

export enum ApprovalProgressStatus {
  PENDING = 'Needs review',
  APPROVED = 'Approved with unapplied changes',
  COMPLETED = 'Completed',
  DECLINED = 'Declined',
  FAILED = 'Failed',
}

export enum ApprovalRequestKind {
  DELETE_SCHEDULED_CHANGE = 'Delete scheduled change',
  SCHEDULE_CHANGES = 'Schedule changes',
  UPDATE_FLAG = 'Update flag',
}

export const DESCRIPTION_MAX_LENGTH = 5000;

export enum ApprovalInstructionKindForMultipleValueResources {
  ADD_REVIEWERS = 'addReviewers',
}
